module.exports = __webpack_public_path__ + "static/media/monitor2.e5f25cf5.png";